// ============================================================================
// File: components/layout/DashboardHeader.jsx
// Purpose: Dashboard title section
// ============================================================================

import React from "react";

export default function DashboardHeader() {
  return (
    <div className="dashboard-header">
      <h2>Procurement Dashboard</h2>
      <p>Real-time procurement insights and operational status</p>
    </div>
  );
}
